export const ru = {
    adaptive: 'Адаптивный',
    create: 'Создать на основе'
};
